<template>
  <b-card
    v-if="data"
    no-body
  >
    <b-card-header>
      <h4 class="mb-0">
        {{ $t('Balance Info') }}
      </h4>
    </b-card-header>

    <!--    <app-echart-bar-->
    <!--      style="width:100%;height:100%;min-height: 300px"-->
    <!--      :option-data="option"-->
    <!--    />-->
    <e-charts
      ref="chart"
      style="width:100%;height:100%;min-height: 300px"
      autoresize
      :options="option"
      theme="theme-color"
      auto-resize
    />
  </b-card>
</template>

<script>
/* eslint-disable */
import {
  BCard, BCardHeader,
} from 'bootstrap-vue'

import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'
import { $themeColors } from '@themeConfig'
import theme from '@core/components/charts/echart/theme.json'
import { kFormatter } from '@core/utils/filter'
//
ECharts.registerTheme('theme-color', theme)

// eslint-disable-next-line no-unused-vars
const currentDate = new Date()
// eslint-disable-next-line no-unused-vars
function GetDaysInMonth(month, year) {
  return new Date(year, month, 0).getDate()
}

export default {
  components: {
    BCard,
    BCardHeader,
    ECharts,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      option: {
        // visualMap: [{
        //   show: true,
        //   type: 'continuous',
        //   min: 0,
        //   max: 400,
        // }],
        xAxis: [
          {
            axisTick: {
              alignWithLabel: true,
            },
            splitLine: {
              show: true,
              lineStyle: {},
            },
            data: Array.from({ length: GetDaysInMonth(currentDate.getMonth()+1, currentDate.getFullYear()) }, (_, i) => `${i + 1}`),
          },
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {},
            },
            axisLabel: {
              formatter : (v)=> `${kFormatter(v)}`
            }
          },
        ],
        legend: {
          right: '20px',
          top: '5px',
        },
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: '60px',
          right: '20px',
          bottom: '40px',
          top: '40x',
        },
        series: [{
          name: this.$t('Commission'),
          data: this.data.series[0].data,
          type: 'bar',
          lineStyle: {
            width: 5,
          },
          // color: '#84d0ff',
          barMaxWidth: '20%',
          barMinWidth: '10px',
          stack: 'balance',
        }, {
          name: this.$t('Turn Over'),
          data: this.data.series[1].data,
          type: 'bar',
          lineStyle: {
            width: 5,
          },
          // color: '#299aff',
          barMaxWidth: '20%',
          barMinWidth: '10px',
          stack: 'balance',
        }, {
          name: this.$t('Win / Lose'),
          data: this.data.series[2].data,
          type: 'bar',
          lineStyle: {
            width: 5,
          },
          color: '#eef1f4',
          barMaxWidth: '20%',
          barMinWidth: '10px',
          stack: 'balance',
        }],
      },
    }
  },
  computed: {
    skin() {
      return this.$store.state.appConfig.layout.skin
    },
  },
  watch: {
    skin(newSkin) {
      this.updateTheme(newSkin)
    },
    '$i18n.locale': 'refreshLabels',
  },
  mounted() {
    this.updateTheme(this.skin)
  },
  methods: {
    refreshLabels() {
      this.option.series[0].name = this.$t('Commission')
      this.option.series[1].name = this.$t('Turn Over')
      this.option.series[2].name = this.$t('Win / Lose')
      if (this.$refs.chart) this.$refs.chart.mergeOptions(this.option)
    },
    updateTheme(skin) {
      if (skin === 'dark') {
        this.option.xAxis[0].splitLine.lineStyle.color = ['#3b4253']
        this.option.yAxis[0].splitLine.lineStyle.color = ['#3b4253']
        this.option.series[2].color = '#eef1f4';
      } else {
        this.option.xAxis[0].splitLine.lineStyle.color = theme.categoryAxis.splitLine.lineStyle.color
        this.option.yAxis[0].splitLine.lineStyle.color = theme.valueAxis.splitLine.lineStyle.color
        this.option.series[2].color = '';
      }
      this.$refs.chart.mergeOptions(this.option)
    },
  },
}
</script>

<style scoped>

</style>
